import { render, staticRenderFns } from "./RefLinksInfo.vue?vue&type=template&id=4c7df892&scoped=true&"
import script from "./RefLinksInfo.vue?vue&type=script&lang=js&"
export * from "./RefLinksInfo.vue?vue&type=script&lang=js&"
import style0 from "./RefLinksInfo.vue?vue&type=style&index=0&id=4c7df892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7df892",
  null
  
)

export default component.exports